import ColorThemeProvider from './color-theme-provider'
import getColorFromTheme from './get-color-from-theme'
import { Theme } from './theme'


export default ColorThemeProvider
export { getColorFromTheme, Theme }
